import { isTrackedInstanceOfAny, ITrackedClass } from '@models/interfaces/tracked-class';
import { AnnotationNode } from '../annotations';
import { instanceOf, instanceOfAny } from '../decorators/model-utils';
import { SketchControlPoint } from '../features/sketch-control-point';
import { Kb3dObject } from '../kb3d-object';
import { Token } from '../token';
import { CustomMeshNode } from './custom-mesh-node';
import { MeshGroupNode } from './mesh-group-node';
import { MeshNode } from './mesh-node';
import { PrimitiveMeshNode } from './primitive-mesh-node';
import { SketchNode } from './sketch-node';
import { SpaceNode } from './space-node';
import { TextNode } from './text-node';

export function isMeshGroupNode(node: Kb3dObject): node is MeshGroupNode {
    return instanceOf<CustomMeshNode>(node, Token.MeshGroupNode);
}

export function isCustomMeshNode(node: Kb3dObject): node is CustomMeshNode {
    return instanceOf<CustomMeshNode>(node, Token.CustomMeshNode);
}

export function isSketchNode(node: Kb3dObject): node is SketchNode {
    return instanceOf<SketchNode>(node, Token.SketchNode);
}

export function isTextNode(node: Kb3dObject): node is TextNode {
    return instanceOf<TextNode>(node, Token.TextNode);
}

export function isSketchControlPoint(node: Kb3dObject): node is SketchControlPoint {
    return instanceOf<SketchControlPoint>(node, Token.SketchControlPoint);
}

export function isMeshNode(node: Kb3dObject): node is MeshNode {
    return instanceOfAny<MeshNode>(node, ...Token.MeshTokens);
}

export function isPrimitiveMeshNode(node: Kb3dObject): node is PrimitiveMeshNode {
    return instanceOf<PrimitiveMeshNode>(node, Token.PrimitiveMeshNode);
}

export function isSpaceNode(node: Kb3dObject): node is SpaceNode {
    return instanceOf<SpaceNode>(node, Token.SpaceNode);
}

export function isPickable(node: Kb3dObject): node is SpaceNode | AnnotationNode {
    if (node instanceof SpaceNode || node instanceof AnnotationNode) {
        return true;
    } else {
        return false;
    }
}

export function isTrackedMeshNode(node: Kb3dObject): node is ITrackedClass<MeshNode> {
    return isMeshNode(node) && isTrackedInstanceOfAny(node, ...Token.MeshAndGroupTokens);
}
